import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { Button } from '../../../components/Button'
import { messages } from './messages'

interface Props {
  showSendSms: boolean
  onSendDocument: () => void
  onSendSms: () => void
}

export const SendActionsDropdown: React.FC<Props> = ({ showSendSms, onSendDocument, onSendSms }) => {
  const { formatMessage } = useIntl()
  const [open, setOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return

    const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('touchstart', handleOutsideClick)
    }
  }, [open])

  const handleSendDocument = () => {
    setOpen(false)
    onSendDocument()
  }

  const handleSendSms = () => {
    setOpen(false)
    onSendSms()
  }

  return (
    <Container ref={containerRef}>
      <Button
        category="on"
        label={formatMessage(messages.send_actions_button)}
        size="m"
        fontWeight="normal"
        maxWidth="100%"
        onClick={() => setOpen(v => !v)}
      />
      {open && (
        <Menu>
          <MenuItem type="button" onClick={handleSendDocument}>
            {formatMessage(messages.send_actions_waybill)}
          </MenuItem>
          {showSendSms && (
            <MenuItem type="button" onClick={handleSendSms}>
              SMS
            </MenuItem>
          )}
        </Menu>
      )}
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  width: 100%;
`

const Menu = styled.div`
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  right: 0;
  z-index: 10;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.large};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`

const MenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  text-align: left;
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.grey300};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey300};
  }
`
